module.exports = __webpack_public_path__ + "static/img/exam_5.e510549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/webSite/exam_5.png
// module id = epPU
// module chunks = 1